/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SCIMConfigurationRead } from '../models/SCIMConfigurationRead';
import type { SCIMConfigurationUpdate } from '../models/SCIMConfigurationUpdate';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ScimService {
  /**
   * @param firmId
   * @returns SCIMConfigurationRead
   * @throws ApiError
   */
  public static apiScimConfigurationFirmRead(
    firmId: string,
  ): CancelablePromise<SCIMConfigurationRead> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/scim/configuration/firm/{firm_id}',
      path: {
        'firm_id': firmId,
      },
    });
  }
  /**
   * Update the SCIM configuration for the firm. Only one configuration can exist per firm.
   * @param configurationId
   * @param data
   * @returns SCIMConfigurationRead
   * @throws ApiError
   */
  public static apiScimConfigurationUpdate(
    configurationId: string,
    data: SCIMConfigurationUpdate,
  ): CancelablePromise<SCIMConfigurationRead> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/api/scim/configuration/{configuration_id}',
      path: {
        'configuration_id': configurationId,
      },
      body: data,
    });
  }
  /**
   * @param configurationId
   * @returns any
   * @throws ApiError
   */
  public static apiScimConfigurationPartialUpdate(
    configurationId: string,
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'PATCH',
      url: '/api/scim/configuration/{configuration_id}',
      path: {
        'configuration_id': configurationId,
      },
    });
  }
}
